import { Component, type ErrorInfo, type ReactNode } from "react";
import { copy } from "../copy";

interface Props {
  children: ReactNode;
  variant?: "page" | "section";
  resetKey?: string;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error(error, info.componentStack);
  }

  componentDidUpdate(previous: Props): void {
    if (previous.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (this.props.variant === "section") {
      return (
        <div className="section-error" role="alert">
          <p>{copy.error.section}</p>
          <button type="button" className="button line" onClick={() => this.setState({ error: null })}>
            {copy.error.retry}
          </button>
          <p className="error-detail">{error.message}</p>
        </div>
      );
    }
    return (
      <div className="gate">
        <div className="gate-card">
          <h1>{copy.error.title}</h1>
          <p>{copy.error.body}</p>
          <button type="button" className="button primary" onClick={() => window.location.reload()}>
            {copy.error.reload}
          </button>
          <p className="error-detail">{error.message}</p>
        </div>
      </div>
    );
  }
}
